import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Activity, Droplets, Flame } from 'lucide-react';
export function Problem() {
  const symptoms = [{
    icon: Brain,
    text: 'Afternoon brain-fog haze'
  }, {
    icon: Activity,
    text: "11 PM 'second wind' of anxiety"
  }, {
    icon: Droplets,
    text: "Stubborn 'cortisol belly'"
  }, {
    icon: Flame,
    text: 'A fuse so short it scares you'
  }];
  return <section className="bg-navy-900 text-cream-100 py-24 px-6 relative overflow-hidden" data-id="element-124">
      <div className="container mx-auto max-w-5xl" data-id="element-125">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-126">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-127">
            <h2 className="font-serif text-4xl md:text-5xl text-gold-500 mb-8" data-id="element-128">
              The Cortisol Flip
            </h2>

            <div className="space-y-6 text-cream-300 text-lg font-light leading-relaxed" data-id="element-129">
              <p data-id="element-130">
                Most women living with high stress develop what we call the
                "Cortisol Flip."
              </p>
              <p data-id="element-131">
                Normally, your stress hormones should be high in the morning and
                low at night. But after months of pushing through, your curve
                has flipped.
              </p>
              <p data-id="element-132">
                You spend your afternoons in a brain-fog haze, only to hit a
                "second wind" of anxiety the moment your head hits the pillow.
              </p>
              <p className="text-cream-50 font-medium" data-id="element-133">
                This state of constant high-alert isn't just making you tired;
                it's causing physical changes.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-navy-800/50 border border-gold-500/20 rounded-2xl p-8 backdrop-blur-sm" data-id="element-134">
            <h3 className="font-serif text-2xl text-cream-50 mb-8 border-b border-gold-500/20 pb-4" data-id="element-135">
              The Symptoms
            </h3>

            <ul className="space-y-6" data-id="element-136">
              {symptoms.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4 + index * 0.1
            }} className="flex items-center gap-4 text-cream-200" data-id="element-137">
                  <div className="bg-gold-500/10 p-3 rounded-full text-gold-500" data-id="element-138">
                    <item.icon size={20} data-id="element-139" />
                  </div>
                  <span className="text-lg" data-id="element-140">{item.text}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}